// extracted by mini-css-extract-plugin
module.exports = {"modal":"StoreSwitchModal_modal__3Yvyu"};